enum TrackerMode {
  DEMO = 'demo',
  NORMAL = 'normal',
}

export default TrackerMode;
